<template>
  <div>
     <div v-if="error">
      Error loading record list
    </div>
    <div v-if="loading">
      Loading record list <i class="fa fa-refresh fa-spin"></i>
    </div>
    <div v-if="loaded">
      <table class="table table-hover">
        <thead>
        <tr>
          <th></th>
          <th>APN</th>
          <th>NAME</th>
        </tr>
        </thead>
        <tbody>
        <tr v-bind:key="record.id" v-for="record in records">
          <td>
            <router-link class="btn btn-primary"
                         :to="{ name: 'Detail', params: { id: record.id }}">
              <i class="fa fa-folder-open-o"></i>
            </router-link>
          </td>
          <td><span style="white-space:nowrap;">{{ record.apn }}</span></td>
          <td>{{ record.name }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "record-list",
  computed: mapState(["records"]),
  data() {
    return {
      loading: true,
      loaded: false,
      error: false
    };
  },
  mounted: function() {
    let self = this;
    this.$store.dispatch("loadRecords").then(
      function() {
        self.loading = false;
        self.error = false;
        self.loaded = true;
      },
      function() {
        self.error = true;
        self.loading = false;
        self.loaded = false;
        console.log("error loading record list");
      }
    );
  }
};
</script>
